import CartItem from "@/components/atoms/CartItem/CartItem";
import type { CartItemMaybeHooked } from "@/lib/hooks/useSelection/cart/useItems";

const CartItems = ({
  items,
  showQuantity = false,
}: {
  items: CartItemMaybeHooked[] | null;
  showQuantity?: boolean;
}) => (
  <>
    {items?.map((item, i) => {
      return (
        <CartItem
          item={item}
          key={`${item.line}-${i}`}
          quantity={showQuantity}
        />
      );
    })}
  </>
);

export default CartItems;
